import { render, staticRenderFns } from "./trade-results-page.vue?vue&type=template&id=7def85d8&scoped=true&"
import script from "./trade-results-page.vue?vue&type=script&lang=js&"
export * from "./trade-results-page.vue?vue&type=script&lang=js&"
import style0 from "./trade-results-page.vue?vue&type=style&index=0&id=7def85d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def85d8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VContainer,VFlex,VIcon,VLayout,VMain,VTab,VTabItem,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7def85d8')) {
      api.createRecord('7def85d8', component.options)
    } else {
      api.reload('7def85d8', component.options)
    }
    module.hot.accept("./trade-results-page.vue?vue&type=template&id=7def85d8&scoped=true&", function () {
      api.rerender('7def85d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/results-pages/trade-results-page.vue"
export default component.exports